<span
	class="freud-icon freud-icon-md freud-icon-edit"
	[pTooltip]="'Prontuário e notas'"
	tooltipPosition="top"
	(click)="emDisplayStateChange.emit('sidebar')"
></span>

<span
	class="freud-icon freud-icon-md freud-icon-messages"
	[pTooltip]="'Chat'"
	tooltipPosition="top"
	(click)="emDisplayStateChange.emit('chat')"
></span>
